import { render, staticRenderFns } from "./bimProductCard.vue?vue&type=template&id=bcb5bf06&scoped=true&"
import script from "./bimProductCard.vue?vue&type=script&lang=js&"
export * from "./bimProductCard.vue?vue&type=script&lang=js&"
import style0 from "./bimProductCard.vue?vue&type=style&index=0&id=bcb5bf06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb5bf06",
  null
  
)

export default component.exports